"use client"

import { Card, Col, Row } from "antd"
import QuickNavigation from "./QuickNavigation"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTranslation } from "react-i18next"
import Title from "@/components/common/Typography/Title"
import Text from "@/components/common/Typography/Text"
import DrawerFormSearchFlightWrapper from "@/components/flight/FormSearch/mobile/DrawerFormSearchFlightWrapper"
import FormSearchFlightHome from "@/components/flight/FormSearch/mobile/FormSearchFlightHome"

const MOBILE_HERO_IMAGE = "/static/images/banners/background-top-mobile.png"

const SearchingVendorMobile = () => {
  const isDesktop = useIsDesktop()
  const { t } = useTranslation()

  if (isDesktop) {
    return <></>
  }

  return (
    <Row className="home__searching mobile">
      <Col span={24}>
        <div className="home__searching--mobile-hero">
          <img
            src={MOBILE_HERO_IMAGE}
            alt=""
            fetchPriority="high"
            decoding="async"
            className="home__searching--mobile-hero-img"
          />
          <div className="home__searching--mobile-hero-copy">
            <Title level={2} className="home__searching--mobile-hero-title">
              {t("home.hero_mobile_title")}
            </Title>
            <Text className="home__searching--mobile-hero-desc">
              {t("home.hero_mobile_desc")}
            </Text>
          </div>
        </div>
        <DrawerFormSearchFlightWrapper>
          <div className="home__searching--quicknav-box">
            <Card size="small" className="home__searching-flight-card">
              <FormSearchFlightHome />
            </Card>
            <QuickNavigation />
          </div>
        </DrawerFormSearchFlightWrapper>
      </Col>
    </Row>
  )
}

export default SearchingVendorMobile
